import { SerializedData } from 'bernie-core';
import { ActivityDestinationViewSearch, ActivityUdsToken } from '../../../common/__generated__/api';
import Fields = ActivityDestinationViewSearch.Fields;

/**
 *
 * ******************** TODO *****************************
 * Need to standardize on one sortAndFilter mapping.
 * The UI should not be handling complex mapping as below.
 * *******************************************************
 *
 */

export const initializeSortAndFilterObject = (
  sortAndFilterSections: ActivityDestinationViewSearch.SortAndFilterSections[]
): SerializedData => {
  let filters: SerializedData | undefined = {};
  let initialSelectedSort = '';
  let keywordPlaceholder = '';
  let keywordValue = '';

  sortAndFilterSections.forEach((filterSection: ActivityDestinationViewSearch.SortAndFilterSections) => {
    filters =
      filterSection &&
      filterSection.fields?.reduce((map: SerializedData, current: Fields) => {
        map[current.id] = map[current.id] || {};
        if (current.udsToken === ActivityUdsToken.TEXT) {
          current = current as ActivityDestinationViewSearch.ActivityTextInputSortFieldInlineFragment;
          keywordPlaceholder = current.placeholder;
          keywordValue = current.value ? current.value : '';
        } else {
          (current as ActivityDestinationViewSearch.ActivitySelectionFieldInlineFragment).options.forEach(option => {
            if (current.id === 'sort' && option.selected) {
              initialSelectedSort = option.value;
            } else {
              map[current.id][option.value] = { selected: option.selected, enabled: option.enabled };
              if (option.nestedOptions && option.nestedOptions.length > 0) {
                option.nestedOptions.forEach(nestedOption => {
                  map[current.id][nestedOption.value] = { selected: nestedOption.selected, enabled: option.enabled };
                });
              }
            }
          });
        }

        return map;
      }, {});
  });

  return { filters, initialSelectedSort, keywordPlaceholder, keywordValue };
};
